import {IMediaDependencyEntry} from './IMediaDependencyEntry';
import moment from 'moment';
import {ShowMetaData} from '../../../../domain/show';

export class MediaDependencyEntryViewModel implements IMediaDependencyEntry {

  constructor(
    public SourceType: string,
    public SourceName: string,
    public StartTimeUTC: string,
    public Duration: string,
    public HasEditSchedulerPermission: boolean,
    public IsAutomaticResolveByRemovingShowDoable: boolean,
    public IsAutomaticResolveByConvertToContractDoable: boolean,
  ) {
  }

}

export class SchedulerDependencyEntryViewModel extends MediaDependencyEntryViewModel {
  constructor(
    public SourceType: string,
    public SourceName: string,
    public StartTimeUTC: string,
    public Duration: string,
    public HasEditSchedulerPermission: boolean,
    public IsAutomaticResolveByRemovingShowDoable: boolean,
    public IsAutomaticResolveByConvertToContractDoable: boolean,
    public ChannelId: number,
    public ShowGuid: string,
    public ShowStartTimeUtc: moment.Moment,
    public ShowDurationMs: number,
    public ShowSomMs: number,
    public ShowName: string,
    public IsShowAnchor: boolean,
    public ShowMetadata:ShowMetaData

  ) {
    super(SourceType, SourceName, StartTimeUTC, Duration, HasEditSchedulerPermission, IsAutomaticResolveByRemovingShowDoable,IsAutomaticResolveByConvertToContractDoable);
  }
}

